import React, { useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-creative';
import { EffectCreative, Pagination, Autoplay } from 'swiper/modules';
import './testimonial.scss';
import PlazaAuto from '../../../assets/logoclient/plazaauto.png';
import UnivBsi from '../../../assets/logoclient/bsiuniv.png';
import AOS from 'aos';
import 'aos/dist/aos.css';

const testimonialsData = [
  {
    id: 1,
    name: 'Plaza Auto - Bapak Fuad',
    position: 'IT SPV Group Plaza Auto',
    description:
      '"We have collaborated with Remala Abadi as an Internet network provider, which supports the network connection we need to run the company ERP system. Our ERP system runs well and is connected between our sales branches to facilitate sales and administration processes."',
    image: PlazaAuto,
  },
  {
    id: 2,
    name: 'Bina Sarana Informatika University',
    position: '',
    description:
      '"PT Remala Abadi Tbk provides good internet service for us at BSI Group. It is easy to contact the Support team and we also been contact by the after sales team that contact and put attention to us every month. The internet can accommodate whole interactive and digital activities that we need on our beloved campus and if there are problems, we are alert by the Customer Service team and we received quick and best solution for our network issue.We hope to continue the service which has been deliver since 2014 with PT Remala Abadi Tbk"',
    image: UnivBsi,
  },
];

const Testimonial = () => {
  useEffect(() => {
    AOS.init({
      duration: 1300,
    });
  }, []);

  return (
    <>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
        <path
          fill="#095493"
          fillOpacity="1"
          d="M0,64L21.8,101.3C43.6,139,87,213,131,224C174.5,235,218,181,262,133.3C305.5,85,349,43,393,69.3C436.4,96,480,192,524,208C567.3,224,611,160,655,128C698.2,96,742,96,785,112C829.1,128,873,160,916,154.7C960,149,1004,107,1047,74.7C1090.9,43,1135,21,1178,37.3C1221.8,53,1265,107,1309,128C1352.7,149,1396,139,1418,133.3L1440,128L1440,320L1418.2,320C1396.4,320,1353,320,1309,320C1265.5,320,1222,320,1178,320C1134.5,320,1091,320,1047,320C1003.6,320,960,320,916,320C872.7,320,829,320,785,320C741.8,320,698,320,655,320C610.9,320,567,320,524,320C480,320,436,320,393,320C349.1,320,305,320,262,320C218.2,320,175,320,131,320C87.3,320,44,320,22,320L0,320Z"
        ></path>
      </svg>
      <div className="containerTestimoni">
        <div className="headersTestimoni" data-aos="fade-up">
          <h3>CUSTOMER TESTIMONIALS</h3>
          <h4>What they say about us?</h4>
        </div>
        <Swiper
          grabCursor={true}
          effect={'creative'}
          creativeEffect={{
            prev: {
              shadow: true,
              translate: [0, 0, -400],
            },
            next: {
              translate: ['100%', 0, 0],
            },
          }}
          autoplay={{
            delay: 10000,
            disableOnInteraction: false,
          }}
          pagination={{
            clickable: true,
          }}
          modules={[EffectCreative, Pagination, Autoplay]}
          className="mySwiper2"
          data-aos="fade-up"
        >
          {testimonialsData.map((testimonial) => (
            <SwiperSlide className="sliderCard" key={testimonial.id}>
              <div className="topCard">
                <div className="imgWrapper">
                  <img src={testimonial.image} alt={testimonial.name} />
                </div>
                <div className="identity">
                  <h5>{testimonial.name}</h5>
                  <p>{testimonial.position}</p>
                </div>
              </div>
              <span className="borderLineTesti"></span>
              <div className="bottomCard">
                <p>{testimonial.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </>
  );
};

export default Testimonial;
